<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card narrow">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ editQuestion.id ? $t('addquestion.edit_title') : $t('addquestion.new_title') }} {{ $t('addquestion.title_suffix') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body">
					<div class="field">
						<label class="label">{{ $t('addquestion.name_label') }}</label>
						<div class="control">
							<input
								type="text"
								v-model="question.name"
								class="input"
								:placeholder="$t('addquestion.name_placeholder')"
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">{{ $t('addquestion.description_label') }}</label>
						<div class="control">
							<textarea
								v-model="question.description"
								rows="2"
								class="textarea"
								:placeholder="$t('addquestion.description_placeholder')"
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">{{ $t('addquestion.law_link_label') }}</label>
						<div class="control">
							<input
								type="text"
								v-model="question.lawLink"
								class="input"
								:placeholder="$t('addquestion.law_link_placeholder')" 
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">{{ $t('addquestion.law_label') }}</label>
						<div class="control">
							<textarea
								v-model="question.law"
								rows="2"
								class="textarea"
								:placeholder="$t('addquestion.law_placeholder')"
							/>
						</div>
					</div>
					<div class="columns">
						<div class="field column">
							<label class="label">{{ $t('addquestion.positive_label') }}</label>
							<div class="control">
								<input
									type="text"
									v-model="question.positive"
									class="input"
									:placeholder="$t('addquestion.positive_placeholder')" 
								/>
							</div>
						</div>
						<div class="field column">
							<label class="label">{{ $t('addquestion.negative_label') }}</label>
							<div class="control">
								<input
									type="text"
									v-model="question.negative"
									class="input"
									:placeholder="$t('addquestion.negative_placeholder')"
								/>
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot">
					<button
						class="button is-dark"
						:class="isLoading ? 'is-loading' : ''"
						:disabled="disableSave"
						@click="save"
					>
						<span class="icon is-info"><i class="fas fa-save"/></span
						><span>{{ $t('addquestion.save_button') }}</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		editQuestion: Object
	},
	data() {
		return {
			question: {
				name: '',
				description: '',
				law: '',
				lawLink: '',
				positive: '',
				negative: ''
			},
			isLoading: false
		};
	},
	watch: {
		editQuestion: {
			handler: function(to) {
				if (to.name) {
					Object.assign(this.question, this.editQuestion);
				} else {
					this.question = {};
				}
			}
		}
	},
	computed: {
		disableSave() {
			let q = this.question;

			return !q.name || !q.positive || !q.negative;
		}
	},
	methods: {
		save() {
			if (!this.isLoading) {
				this.$emit('save', this.question);
			}

			this.isLoading = true;
		},
		cancel() {
			this.$emit('cancel');
		}
	},
	created() {
		if (this.editQuestion) {
			Object.assign(this.question, this.editQuestion);
		}
	}
};
</script>
